import { useToast } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCheckAnalysisGuideMisMatch } from 'src/api/GuidesAPI';
export var AnalysisGuide = function AnalysisGuide(_ref) {
  var children = _ref.children;

  var _useRouter = useRouter(),
      _useRouter$query = _useRouter.query,
      clientID = _useRouter$query.clientID,
      soapID = _useRouter$query.soapID;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useCheckAnalysisGuid = useCheckAnalysisGuideMisMatch(soapID, clientID),
      isMisMatch = _useCheckAnalysisGuid.isMisMatch,
      loading = _useCheckAnalysisGuid.loading;

  var toast = useToast();
  useEffect(function () {
    if (!isMisMatch || loading) {
      return;
    }

    toast({
      title: t('analysis_guide:misMatch', 'Client ID 與 Soap ID 不相匹配！避免資料錯誤，請由顧客頁診療單內「分析工具」按鈕進入此頁'),
      description: '',
      status: 'error',
      duration: null,
      isClosable: true,
      position: 'top'
    });
  }, [isMisMatch, loading, toast, t]);
  return /*#__PURE__*/React.cloneElement(children, {
    isMisMatch: isMisMatch
  });
};